/**
 * Login API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const loginApi = {
    // 로그인(login)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-account-sign-in-password-and-social
    login(params) {
        return httpService.post('/auth/login', params)
    },

    // 로그 아웃(logout)
    // 
    logout() {
        return httpService.put('/auth/logout')
    },

    // 토큰 유효성 체크(Token Validity Check)
    validToken() {
        return httpService.get('/auth/valid')
    },

    // 헤더 토큰 설정(set Header Token)
    setAuthInHeader(token) {
        localStorage.setItem('token', token)
        httpService.setAuthInHeader(token)
    }
}

export default loginApi